import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksBillForm', {
    removeMatchingConfirmation:
        'You are about to make changes that will remove the link with the matched Purchase Order. Do you want to proceed?',
    confirmChanges: 'Confirm Changes',
    headerText: 'Bill details',
});
